module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "brand-filters"
  }, _vm._l((_vm.brandValidation), function(bv) {
    return (bv.CompetitorCarBrand) ? _c('div', {
      key: bv.CompetitorCarBrand,
      staticClass: "brand-tag"
    }, [_c('span', {
      staticClass: "brand-name"
    }, [_vm._v("\n          " + _vm._s(bv.CompetitorCarBrand) + " (" + _vm._s(bv.Distribution) + "%)\n        ")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.lang.W00044))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00045))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00041))]), _vm._v(" "), _c('div')]), _vm._v(" "), (_vm.competitorCarModelDistribution) ? _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.competitorCarModelDistribution), function(e, index) {
    return _c('div', {
      key: index,
      staticClass: "wizard-table-row",
      class: {
        'invalid-wizard-table-row': !_vm.isBrandValid(e.CompetitorCarBrand)
      }
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.CompetitorCarBrand),
        expression: "e.CompetitorCarBrand"
      }],
      staticClass: "wizard-select",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(e, "CompetitorCarBrand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00047))]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
      return _c('option', {
        key: brand,
        domProps: {
          "value": brand
        }
      }, [_vm._v("\n                " + _vm._s(brand) + "\n              ")])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.CompetitorCarModel),
        expression: "e.CompetitorCarModel"
      }],
      staticClass: "wizard-input",
      attrs: {
        "type": "text",
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (e.CompetitorCarModel)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(e, "CompetitorCarModel", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.Distribution),
        expression: "e.Distribution"
      }],
      staticClass: "wizard-input",
      attrs: {
        "type": "number",
        "min": 0,
        "max": 100,
        "step": 0.1,
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (e.Distribution)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(e, "Distribution", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('button', {
      staticClass: "delete-vehicle-btn",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "click": function($event) {
          return _vm.deleteVehicle(e)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("delete")])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-vehicle-btn-container"
  }, [_c('button', {
    staticClass: "add-vehicle-btn",
    attrs: {
      "disabled": _vm.readonly
    },
    on: {
      "click": function($event) {
        return _vm.addVehicle()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.W00046))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff6c074a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/Step4.vue
// module id = 1741
// module chunks = 1